import { Box, Card, Stack, Heading, Text, Divider } from 'braid-design-system';

import type { ListingProduct } from 'src/generated/graphql';
import { decimalFormatPriceBand } from 'src/utils/investmentBands';

interface EmailAndSearchBoostProductDetailsProps {
  emailBoostProduct: ListingProduct;
  searchBoostProduct: ListingProduct;
  emailAndSearchBoostProduct: ListingProduct;
}

export const EmailAndSearchBoostProductDetails = (
  props: EmailAndSearchBoostProductDetailsProps,
) => (
  <Card data={{ testid: 'email-and-search-boost-product-details' }}>
    <Box paddingBottom="large">
      <Heading level="3">Boost packages</Heading>
    </Box>

    <Stack space="medium">
      <Box
        display="flex"
        justifyContent="spaceBetween"
        alignItems="center"
        data={{ testid: 'boost-bundle-product-details-search-boost-row' }}
      >
        <Stack space="small">
          <Text weight="strong">Website Search Boost</Text>
          <Text tone="secondary">
            Stand out where it matters – at the top of search results and on our
            homepage for buyers in your location.
          </Text>
        </Stack>

        <Box flexShrink={0} paddingLeft={{ mobile: 'xsmall', tablet: 'large' }}>
          <Text
            weight="regular"
            data={{
              testid: 'boost-bundle-product-details-search-boost-price',
            }}
          >
            {decimalFormatPriceBand(props.searchBoostProduct.cost / 100)}
          </Text>
        </Box>
      </Box>

      <Box
        display="flex"
        justifyContent="spaceBetween"
        alignItems="center"
        data={{ testid: 'boost-bundle-product-details-search-email-row' }}
      >
        <Stack space="small">
          <Text weight="strong">Email Boost</Text>
          <Text tone="secondary">
            Reach motivated buyers directly – get featured at the top of our
            daily recommendation emails.
          </Text>
        </Stack>

        <Box flexShrink={0} paddingLeft={{ mobile: 'xsmall', tablet: 'large' }}>
          <Text
            weight="regular"
            data={{
              testid: 'boost-bundle-product-details-email-boost-price',
            }}
          >
            {decimalFormatPriceBand(props.emailBoostProduct.cost / 100)}
          </Text>
        </Box>
      </Box>

      <Divider />

      <Box
        display="flex"
        justifyContent="spaceBetween"
        alignItems="center"
        paddingY="xxsmall"
      >
        <Text size="large" weight="medium">
          Total:
        </Text>

        <Text
          size="large"
          weight="medium"
          data={{ testid: 'boost-bundle-product-details-total-price' }}
        >
          {decimalFormatPriceBand(props.emailAndSearchBoostProduct.cost / 100)}{' '}
          + GST
        </Text>
      </Box>
    </Stack>
  </Card>
);
